import { db } from '.././firestoreConfig';
import { collection, getDocs, getDoc, setDoc, doc} from "firebase/firestore"

class BasketDataService {
    async getAll() {
        const colRef = collection(db, 'users')
        var docs = [];
        const querySnapshot = await getDocs(colRef);
        querySnapshot.forEach((doc) => {
            if(doc.exists){
                console.log(doc.id, " => ", doc.data());
                docs.push( doc.data());
            }
        });
        return docs;
    }
    async add2basket(userId,prodAndQuantity){
        const docRef = doc(db, `users/${userId}/objects/cart`);
        //await db.doc(`/users/${userId}/objects/cart`).set(prodAndQuantity)

        const pli = prodAndQuantity;
        try{
            await setDoc(docRef, pli, { merge: true });
        }catch(error){
            const errorCode = error.code;
            const errorMessage = error.message;
            console.error("Error: ", errorCode, errorMessage);   
        }
    }
    async getBasket(userId) {
        const docRef = doc(db, `users/${userId}/objects/cart`);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            try {
                let cart = { init: true, items: [], subtotal: 0, total: 0  };
                await db.doc(`users/${userId}/objects/cart`).set(cart)
            } catch (exception) {
                console.log(exception);
            }
        }
    }
}

export default new BasketDataService();